import { type ReactNode } from 'react';

// ** MUI Imports
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';

// ** Icon Imports
import FaIconUvilo from '@erikdakoda/ui/components/FaIconUvilo';

// ** Type Import
import type { Settings } from '@erikdakoda/site-template-ui/context/settingsContext';

// ** Components
import VerticalNavFooter from './VerticalNavFooter';

interface Props {
  hidden: boolean;
  settings: Settings;
  toggleNavVisibility: () => void;
  saveSettings: (values: Settings) => void;
  branding: (props?: object) => ReactNode;
}

const AppBarContent = (props: Props) => {
  // ** Props
  const { hidden, branding, toggleNavVisibility } = props;

  return (
    <Box
      sx={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}
    >
      <Box className="actions-left" sx={{ display: 'flex', alignItems: 'center', minWidth: 82 }}>
        {hidden ? (
          <IconButton color="inherit" onClick={toggleNavVisibility}>
            <FaIconUvilo icon="bars" />
          </IconButton>
        ) : null}
      </Box>
      <Box>{branding()}</Box>
      <Box className="actions-right" sx={{ display: 'flex', alignItems: 'center' }}>
        <VerticalNavFooter />
      </Box>
    </Box>
  );
};

export default AppBarContent;
